import React from 'react';

interface CustomerAvatarsProps {
  /**
   * Array of avatar image URLs
   */
  avatars?: string[];
  /**
   * Number of customers to display
   */
  customerCount?: string;
  /**
   * Size of the avatar images (in pixels)
   */
  size?: 'sm' | 'md' | 'lg';
  /**
   * Layout direction of the component
   */
  layout?: 'vertical' | 'horizontal';
  /**
   * Additional CSS classes for the container
   */
  className?: string;
}

/**
 * CustomerAvatars component displays a stack of customer avatars with a count
 * to showcase popularity and social proof
 */
export const CustomerAvatars: React.FC<CustomerAvatarsProps> = ({
  avatars = [
    'https://storage.prompt-hunt.workers.dev/0fbbc50f-f824-49da-8f33-86c23cfa1cdc',
    'https://storage.prompt-hunt.workers.dev/0e215b6b-3b00-4ba1-835a-309ec76cf538',
    'https://storage.prompt-hunt.workers.dev/4e4ddd7d-e997-48fd-9182-7048db2262ae',
    'https://storage.prompt-hunt.workers.dev/d8ae8f9a-9f34-47b7-beb1-a8d455e63c34'
  ],
  customerCount = '86,000+ customers',
  size = 'md',
  layout = 'vertical',
  className = ''
}) => {
  // Determine avatar size based on the size prop
  const avatarSizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8'
  };

  // Determine container classes based on layout
  const containerClasses = `flex ${
    layout === 'vertical'
      ? 'flex-col gap-2 justify-center items-center font-bold text-xs '
      : 'flex-row items-center gap-2 font-medium text-base'
  } text-foreground ${className}`;

  return (
    <div className={containerClasses}>
      <div className="flex -space-x-2">
        {avatars.map((src, index) => (
          <img
            key={index}
            className={`inline-block ${avatarSizeClasses[size]} rounded-full ring-2 ring-background`}
            src={src}
            alt={`Customer ${index + 1}`}
          />
        ))}
      </div>
      {/* <div className="font-bold whitespace-nowrap text-xs">#1 AI Portrait App</div> */}

      <div className="whitespace-nowrap">{customerCount}</div>
    </div>
  );
};

export default CustomerAvatars;
